import { render, staticRenderFns } from "./ms-invite-referral.vue?vue&type=template&id=245a1514&scoped=true"
import script from "./ms-invite-referral.vue?vue&type=script&lang=js"
export * from "./ms-invite-referral.vue?vue&type=script&lang=js"
import style0 from "./ms-invite-referral.vue?vue&type=style&index=0&id=245a1514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245a1514",
  null
  
)

export default component.exports